import React, { PureComponent } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import styled from "styled-components";

const data = [
  { name: "Low Risk", value: 100, range: "0-3" },
  { name: "Risky", value: 100, range: "4-9" },
  { name: "Harmful", value: 100, range: "10-13" },
  { name: "Severe", value: 100, range: "14+" },
];
const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const CenterText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
  z-index: 10;
`;

const ScoreNumber = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  color: ${props => props.color || "#333"};
  line-height: 1;
  margin-bottom: 0.2rem;
`;

const ScoreLabel = styled.div`
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
`;

export default class PieChartComponent extends PureComponent {
  render() {
    let auditIndex = data.findIndex((i) => i.name === this.props.selected);
    const selectedData = data[auditIndex] || data[0];
    const selectedColor = COLORS[auditIndex] || COLORS[0];

    return (
      <div style={{ 
        width: "100%", 
        height: "250px", 
        maxWidth: "350px", 
        margin: "auto",
        padding: "20px 20px 40px 20px",
        position: "relative"
      }}>
        <PieChart width={350} height={250}>
          {/* Main pie chart */}
          <Pie
            activeIndex={auditIndex}
            data={data}
            innerRadius="40%"
            outerRadius="70%"
            dataKey="value"
            paddingAngle={2}
            cx="50%"
            cy="50%"
          >
            {data.map((entry, index) => {
              const isSelected = index === auditIndex;
              const isSevere = entry.name === "Severe";
              const shouldMagnify = isSelected && isSevere;
              
              return (
                <Cell 
                  key={`cell-${index}`} 
                  fill={COLORS[index % COLORS.length]}
                  style={{
                    transform: shouldMagnify ? 'scale(1.1)' : 'scale(1)',
                    transformOrigin: 'center',
                    zIndex: shouldMagnify ? 10 : 1
                  }}
                />
              );
            })}
          </Pie>
        </PieChart>
        <CenterText>
          <ScoreNumber color={selectedColor}>
            {this.props.score || selectedData.range}
          </ScoreNumber>
          <ScoreLabel>
            {selectedData.name}
          </ScoreLabel>
        </CenterText>
      </div>
    );
  }
}
